import React, { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import storage from "../../Assets/js/Global";
import { images } from "../../Assets/images";

const ForgotPassword = () => {
  const { email, sendEmailOTP, setEmail, translatedLabels, logoUrl } =
    useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const handleSubmit = (e) => {
    e.preventDefault();
    sendEmailOTP();
  };
  return (
    <>
      <section id="forgotPasswordPage" className="login-section-bg">
        <div className="container-main">
          <div className="text-center">
            <h4 className="text-white mx-2">
              <div className="d-flex justify-content-center">
                <div className="app-logo">
                  <img
                    src={logoUrl || images.appLogo}
                    alt="app-logo"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = images.appLogo;
                    }}
                  />
                </div>
              </div>
            </h4>
          </div>
          <div className="">
            <h3 className="mt-3 mb-0 text-center">
              {authLabel?.forgot_password?.label_value || "Forgot Password"}
            </h3>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group mb-2">
              <label className="form-label">
                {authLabel?.email?.label_value || "Email"}
              </label>
              <input
                type="email"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_your_email?.label_value || "Enter e-mail"
                }
                value={email}
                onChange={(e) => {
                  const newEmail = e.target.value;
                  setEmail(newEmail);
                  storage.set("verifiedEmail", newEmail);
                }}
              />
            </div>
            <div className="mt-4 text-center">
              <button className="btn btn-primary">
                {authLabel?.submit?.label_value || "Submit"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default ForgotPassword;
